@if (showDropDownGroup(type())) {
  <div class="button-wrapper">
    <div class="fab-icon-holder" [ngClass]="[type(), showDropdown() ? 'engaged-button' : '']">
      <button
        type="button"
        data-testid="dropdown-button"
        [ngClass]="[type(), showDropdown() ? 'dropdown-button active' : 'dropdown-button']"
        [matTooltip]="type() === 'menuGroup' ? 'Group Activities' : 'Presentation'"
        (click)="toggleDropdown($event)"
        (touchStart)="toggleDropdown($event)"
        aria-label="Photo booth"
      >
        <div class="wrapper-icon">
          <mat-icon [svgIcon]="type() === 'menuGroup' ? 'GROUP_SHARE_ICON' : 'PRESENT_TO_ALL_FILLED'"></mat-icon>
        </div>
      </button>
      @if (showNotification()) {
        <div class="notificiation-dot fab-notification">
          {{ notificationText() }}
        </div>
      }
    </div>
  </div>
}

<div
  data-testid="dropdown"
  class="dropdown"
  [ngClass]="{ active: showDropdown(), 'active-group': activeGroup() }"
  (click)="dropdownClicked($event)"
  (touchStart)="dropdownClicked($event)"
>
  <!-- Group Dropdown -->
  @if (type() === 'menuGroup' && showDropDownGroup(type())) {
    <div>
      <div class="options">
        @if (allowSpecialAccessGroup() && showEnableSagButton()) {
          <div class="button-wrapper">
            <button
              type="button"
              class="option"
              (click)="enableSpecialAccessGroup()"
              (touchend)="enableSpecialAccessGroup()"
            >
              <mat-icon svgIcon="DIAMOND_ACCESS"></mat-icon>
              <span class="option-name">Enable Special Access Control</span>
            </button>
          </div>
        }
        @if (showInGroupButton()) {
          <div class="button-wrapper">
            <button
              type="button"
              class="option"
              (click)="disableSpecialAccessGroup()"
              (touchend)="disableSpecialAccessGroup()"
            >
              <mat-icon>lock_open</mat-icon>
              <span class="option-name">Make Group Public</span>
            </button>
          </div>
        }
        @if (showInGroupButton()) {
          <div class="button-wrapper">
            <button type="button" class="option" (click)="openRequestQueue()" (touchend)="openRequestQueue()">
              <mat-icon>library_add</mat-icon>
              <span class="option-name">View Request Queue</span>
              @if (showNotification()) {
                <div class="notificiation-dot">{{ notificationText() }}</div>
              }
            </button>
          </div>
        }
        @if (isGroupSharing()) {
          <div class="button-wrapper">
            <button
              type="button"
              class="option"
              (click)="handleQuickGroupScreenShare()"
              (touchend)="handleQuickGroupScreenShare()"
              [disabled]="isPlayerOutsideGroupLimit()"
            >
              <mat-icon>group_work</mat-icon>
              <span class="option-name">{{ groupShareButtonText() }}</span>
            </button>
          </div>
        }
        @if (allowPhotoBooth()) {
          <div class="button-wrapper">
            <button
              type="button"
              data-testid="photo-booth-btn"
              class="option"
              (click)="showPhotoBoothModal($event)"
              (touchend)="showPhotoBoothModal($event)"
              [disabled]="isGroupSharing()"
            >
              <mat-icon>photo_camera</mat-icon>
              <span class="option-name">Take a group photo</span>
            </button>
          </div>
        }
        @if (userCanShareWithGroup()) {
          <div class="button-wrapper">
            <button
              type="button"
              data-testid="share-screen-group-btn"
              class="option"
              (click)="handleQuickGroupScreenShare()"
              (touchend)="handleQuickGroupScreenShare()"
              [disabled]="isGroupSharing()"
            >
              <mat-icon>present_to_all</mat-icon>
              <span class="option-name">{{ groupShareState.NOT_SHARING }}</span>
            </button>
          </div>
        }
        @if (userCanShareWithGroup() && enhancedScreenShare()) {
          <div class="button-wrapper">
            <button
              type="button"
              data-testid="share-screen-group-btn"
              class="option"
              (click)="handleQuickGroupScreenShare(true)"
              (touchend)="handleQuickGroupScreenShare(true)"
              [disabled]="isGroupSharing()"
            >
              <mat-icon>present_to_all</mat-icon>
              <span class="option-name">{{ groupShareState.NOT_SHARING_ENHANCED }}</span>
            </button>
          </div>
        }
      </div>
    </div>
  }

  <!-- Presentation Dropdown -->
  @if (type() === 'menuPresentation') {
    <div>
      <div class="options">
        @if (canPresentToAllRooms()) {
          <div class="button-wrapper">
            <button
              type="button"
              data-testid="present-btn"
              [disabled]="isSomeoneElsePresenting()"
              class="option present-menu"
              (click)="handleQuickPresent(true)"
              (touchend)="handleQuickPresent(true)"
            >
              <mat-icon>co_present</mat-icon>
              <span class="option-name" matTooltip="Present to Scootaverse" matTooltipPosition="right"
                >Present to All Rooms</span
              >
            </button>
          </div>
        }
        @if (allowAnyonePresent() || isHost()) {
          <div [ngClass]="{ 'last-wrapper': canPresentToAllRooms() }" class="button-wrapper">
            <button
              type="button"
              data-testid="present-btn"
              class="option present-menu"
              (click)="handleQuickPresent(false)"
              (touchend)="handleQuickPresent(false)"
            >
              <mat-icon>co_present</mat-icon>
              <span class="option-name" matTooltip="Present to Scootaverse" matTooltipPosition="right"
                >Present to Room</span
              >
            </button>
          </div>
        }
        @if (canScreenShare()) {
          <div class="button-wrapper last-wrapper">
            <button
              type="button"
              data-testid="share-screen-btn"
              class="option present-menu"
              (click)="handleQuickScreenShare(false)"
              (touchend)="handleQuickScreenShare(false)"
            >
              <mat-icon>screen_share</mat-icon>
              <span class="option-name" matTooltip="Share Screen to room" matTooltipPosition="right">Share screen</span>
            </button>
          </div>
        }
        @if (canScreenShare() && enhancedScreenShare()) {
          <div class="button-wrapper last-wrapper">
            <button
              type="button"
              data-testid="share-screen-btn"
              class="option present-menu"
              (click)="handleQuickScreenShare(true)"
              (touchend)="handleQuickScreenShare(true)"
            >
              <mat-icon>music_video</mat-icon>
              <span class="option-name" matTooltip="Share HD Screen for Video to room" matTooltipPosition="right"
                >Share video stream</span
              >
            </button>
          </div>
        }
        @if (canScreenShare() && vimeoEmbed()) {
          <div class="button-wrapper last-wrapper">
            <button
              type="button"
              data-testid="share-screen-btn"
              class="option present-menu"
              (click)="handleEmbedPresentation(false)"
              (touchend)="handleEmbedPresentation(false)"
            >
              <mat-icon svgIcon="EMBED_VIDEO"></mat-icon>
              <span class="option-name" matTooltip="Share an embedded Video to room" matTooltipPosition="right"
                >Share video link</span
              >
            </button>
          </div>
        }
      </div>
    </div>
  }
</div>

@if (isLoading()) {
  <div class="loading-container">
    <app-loading></app-loading>
    <span class="font-s">{{ loadingText() }}</span>
  </div>
}
